// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductList_wrapper__MdEky","list":"ProductList_list__bk8G8","item":"ProductList_item__lcyTB"};